import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../services/auth-state.service';
import { CREATE_USER_ROLES } from '../constants';

/**
 * Restricts the Create User (license) route to CREATE_USER_ROLES. Non-matching
 * roles — including unauthenticated users — are redirected to /home. Pair with
 * authGuard so the login redirect still applies: `canActivate: [authGuard, createUserGuard]`.
 */
export const createUserGuard: CanActivateFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);

  const role = auth.userProfile()?.role ?? '';
  if (auth.isAuthenticated() && (CREATE_USER_ROLES as readonly string[]).includes(role)) {
    return true;
  }

  return router.createUrlTree(['/home']);
};
